import React, { useContext } from "react";
import pClasses from "../Home.module.scss";
// import RoundButton from "../../../../components/Buttons/RoundButton";
// import ButtonsArea from "../../../../components/Buttons/ButtonsArea";
// import FriendlyInfo from "../../../../components/FriendlyInfo";
// import CardGame from "../../../../components/Cards/CardGame";
import UserTrainingContext from "../../../../context/userTrainingContext";
import Spinner from "../../../../components/Spinner";
// import { useTranslation } from "react-i18next";
// import * as r from "../../../../constants/routes";
// import { useNavigate } from "react-router";
// import { prettySubPathUrl } from "../../../../helpers";
// import SmartGameCard from "../../../../components/Cards/SmartGameCard";
// import { GET_PROD_OR_DEV } from "../../../../constants/api";
import CardsArea from "../../../../components/Cards/CardsArea";
import PageMain from "../../../../components/Main/PageMain";

export default function TabTraining() {
  const tContext = useContext(UserTrainingContext);
  // const history = useNavigate();
  // const { t } = useTranslation();
  const { game_list, active_category, setGameUrl } = tContext ?? {};

  let _content = <Spinner center />;
  let _randomGame = null;
  _randomGame = <></>;
  if (game_list && game_list.length > 0) {
    const filtered_game_list = game_list.filter((game: any) =>
      game.abilities.includes('Foco')
    );
    // const filtered_game_list1 = game_list.filter((game: any) =>
    //   game.abilities.includes('Memória')
    // );
    // const filtered_game_list2 = game_list.filter((game: any) =>
    //   game.abilities.includes('Agilidade Mental')
    // );
    // const filtered_game_list3 = game_list.filter((game: any) =>
    //   game.abilities.includes('Escuta Ativa')
    // );

    const randomGame =
      filtered_game_list[Math.floor(Math.random() * filtered_game_list.length)];
    // const randomGame1 =
    //   filtered_game_list1[Math.floor(Math.random() * filtered_game_list1.length)];
    // const randomGame2 =
    //   filtered_game_list2[Math.floor(Math.random() * filtered_game_list2.length)];
    // const randomGame3 =
    //   filtered_game_list3[Math.floor(Math.random() * filtered_game_list3.length)];

    if (randomGame) {
      // _randomGame = (
      //   <>
      //     <div className={pClasses.row}>
      //       <div className={pClasses.column} style={{ maxWidth: '100%' }}>
      //         <SmartGameCard
      //           key={randomGame.id ?? randomGame.name}
      //           id={randomGame.id}
      //           name={randomGame.name}
      //           image={randomGame.images.thumb}
      //           abilities={randomGame.abilities}
      //           onClick={() => {
      //             history(
      //               prettySubPathUrl(
      //                 r.GET_R_U_TRAIN_GAME_SCREEN('Foco', randomGame.name)
      //               )
      //             );
      //             setGameUrl(
      //               randomGame.activity_urls[GET_PROD_OR_DEV],
      //               randomGame.name
      //             );
      //           }}
      //         />
      //       </div>
      //       <div className={pClasses.column}>
      //         <SmartGameCard
      //           key={randomGame1.id ?? randomGame1.name}
      //           id={randomGame1.id}
      //           name={randomGame1.name}
      //           image={randomGame1.images.thumb}
      //           abilities={randomGame1.abilities}
      //           onClick={() => {
      //             history(
      //               prettySubPathUrl(
      //                 r.GET_R_U_TRAIN_GAME_SCREEN('Memória', randomGame1.name)
      //               )
      //             );
      //             setGameUrl(
      //               randomGame1.activity_urls[GET_PROD_OR_DEV],
      //               randomGame1.name
      //             );
      //           }}
      //         />
      //       </div>
      //     </div>
      //     <div className={pClasses.row}>
      //       <div className={pClasses.column}>
      //         <SmartGameCard
      //           key={randomGame2.id ?? randomGame2.name}
      //           id={randomGame2.id}
      //           name={randomGame2.name}
      //           image={randomGame2.images.thumb}
      //           abilities={randomGame2.abilities}
      //           onClick={() => {
      //             history(
      //               prettySubPathUrl(
      //                 r.GET_R_U_TRAIN_GAME_SCREEN('Foco', randomGame2.name)
      //               )
      //             );
      //             setGameUrl(
      //               randomGame2.activity_urls[GET_PROD_OR_DEV],
      //               randomGame2.name
      //             );
      //           }}
      //         />
      //       </div>
      //       <div className={pClasses.column}>
      //         <SmartGameCard
      //           key={randomGame3.id ?? randomGame3.name}
      //           id={randomGame3.id}
      //           name={randomGame3.name}
      //           image={randomGame3.images.thumb}
      //           abilities={randomGame3.abilities}
      //           onClick={() => {
      //             history(
      //               prettySubPathUrl(
      //                 r.GET_R_U_TRAIN_GAME_SCREEN('Memória', randomGame3.name)
      //               )
      //             );
      //             setGameUrl(
      //               randomGame3.activity_urls[GET_PROD_OR_DEV],
      //               randomGame3.name
      //             );
      //           }}
      //         />
      //       </div>
      //     </div>
      //   </>
      // );
    }

    _content = (
      <>
        <CardsArea >{_randomGame}</CardsArea>
      </>
    );
  }


  return (
    <>
      <PageMain centerStretch className={pClasses.TabSmartTraining}>
        <section>{_content}</section>
      </PageMain>
    </>
  )
}
